 <template>
  <div class="Vow">
    <div v-if="helperInfo" class="vowTop">
      <!-- <div class="vowRule">
        <img @click="showRule" class="ruleBtn" src="../../static/images/activity_rule.png" alt />
        <img @click="goteam" class="ruleBtn2" src="../../static/images/activity_reward.png" alt />
      </div>-->
      <RuleBtn v-bind:fromType="0" v-bind:myuser="myUserInfo" v-on:showPhone="showPhone"></RuleBtn>
      <div class="vowRefresh draw-top text-center">
        <img @click="returnVow" class="draw-allow" src="../../static/images/draw_allow.png" alt />
        <p class="topTotal">
          已有
          <span class="wish-num">{{wishTotal}}人</span>许下星愿
        </p>

        <!-- <div v-if="helperInfo" class="draw-myvow">{{helperInfo.wish_str}}</div> -->
      </div>
      <!-- <div v-if="helperInfo">已助力{{helperInfo.help_num}}人</div> -->
      <Progress
        @showFriend="commOpenModal"
        :helplist="helplist"
        :helpnum="helperInfo.help_num"
        :helpwish="helperInfo.wish_str"
        :maxUser="max_help_user"
      ></Progress>
      <div class="helpBtnView flex-column">
        <div>快去收集好友祝福吧</div>
        <div @click="todraw" class="helpBtn">
          <p class="helpBtnText">
            抽奖
            <span v-if="helperInfo.draw_able_num > 0">（{{helperInfo.draw_able_num}}次）</span>
          </p>
        </div>
        <div @click="goshare" class="draw-more-btn">获得更多抽奖次数>></div>
      </div>
      <!-- <div @click="todraw" class="draw-btn text-center">抽奖({{helperInfo.draw_able_num}})</div> -->
      <!-- <div v-else @click="helpMember" class="draw-btn text-center">我要助力</div> -->
    </div>
    <div class="reward-wrap">
      <Reward v-bind:mypoint="'homepage2#adclick'"></Reward>
    </div>

    <!-- 中奖啦弹窗 -->
    <div v-if="iswin==1 && myaward" class="help-alert-wrap flex-column">
      <div class="help-alert flex-column">
        <div class="help-alert-title">中奖啦</div>
        <div class="help-alert-desc">已放入您的账户，可前往【我的奖品】查看</div>
        <div class="help-alert-gift flex-row">
          <div class="help-alert-gift-left">
            <img
              v-if="myaward && myaward.logo"
              class="help-alert-gift-default"
              :src="myaward.logo"
              alt
            />
            <img
              v-else
              class="help-alert-gift-default"
              src="../../static/images/gift_default.png"
              alt
            />
          </div>
          <div class="help-alert-gift-right flex-data">
            <p class="help-alert-gift-text">{{myaward.award_name}}</p>
            <div class="help-alert-gift-time">有效期至{{activityInfo.end_time_format}}</div>
          </div>
        </div>
        <div class="new-alert-btn flex-row">
          <template>
            <div
              v-if="_getBrowser() == 1"
              @click="useAward"
              class="common-bg help-alert-btn help-alert-btn2"
            >去使用</div>
            <div
              v-else
              class="common-bg help-alert-btn help-alert-btn2 btn-clipboard"
              id="btnH5"
              @click="_downloadAPP(1,'homepage2#pop_getsuccess_appdownload')"
              data-clipboard-target="#hello"
            >去APP使用</div>
            <input type="hidden" id="hello" value style="display:none;" />
          </template>
          <div @click="todraw" class="common-bg help-alert-btn help-alert-btn2">继续抽奖</div>
        </div>
      </div>
      <img @click="closeWin" class="alert-close" src="../../static/images/alert_close.png" alt />
    </div>
    <!-- 未中奖弹窗 -->
    <div v-if="iswin==0" class="help-alert-wrap flex-column">
      <div class="help-alert fail flex-column">
        <div class="help-alert-title">不好意思</div>
        <div class="help-alert-name">{{errMsg}}</div>
        <!-- <div class="help-alert-desc02">下载无忧行领取更多奖励</div> -->
        <div @click="closeWin" class="common-bg help-alert-btn">好的</div>
        <!-- v-if="helperInfo.draw_able_num > 0" <div v-else @click="closeWin" class="common-bg help-alert-btn btn-clipboard">下载无忧行APP</div> -->
      </div>
      <img @click="closeWin" class="alert-close" src="../../static/images/alert_close.png" alt />
    </div>
    <!-- 抽奖机会用完弹窗 -->
    <div v-if="isCountUpper" class="help-alert-wrap flex-column">
      <div class="help-alert fail flex-column">
        <div class="help-alert-title">抽奖机会</div>
        <div class="help-alert-name">抽奖机会已用完</div>
        <div class="help-alert-desc02">快去收集好友祝福吧</div>
        <div @click="moreDraw" class="common-bg help-alert-btn">获得更多抽奖机会</div>
      </div>
      <img @click="closeWin" class="alert-close" src="../../static/images/alert_close.png" alt />
    </div>
    <!-- 规则弹窗 -->
    <RulePopup
      @closeRule="showRule"
      v-if="activityInfo"
      :show="isshowrule"
      :ruleText="activityInfo.rule_desc"
    ></RulePopup>
    <FriendModal :modalStatu="modalStatu" :helplist="helplist" @commHideModal="commHideModal"></FriendModal>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Swipe, SwipeItem, Lazyload, Picker, Toast, Field } from "vant";
import CanvasPoster from "vue-canvas-poster";
import Reward from "../components/Reward.vue";
import Progress from "../components/Progress.vue";
import RulePopup from "../components/RulePopup.vue";
import RuleBtn from "../components/RuleBtn.vue";
import FriendModal from "../components/FriendModal.vue";
Vue.use(CanvasPoster);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Button).use(Lazyload);
Vue.use(Picker)
  .use(Reward)
  .use(Toast)
  .use(Field);

export default {
  name: "Vow",
  components: { Reward, Progress, RulePopup, FriendModal, RuleBtn },
  data() {
    //逻辑
    return {
      helperInfo: null,
      helplist: null,
      isme: 0,
      ishelp: 0,
      iswin: -1,
      myaward: null,
      isshowrule: false,
      isCountUpper: false,
      isCount: false,
      errMsg: "未中奖，换个姿势再试试",
      modalStatu: "hide" //控制好友列表弹窗 friend 打开 hide 关闭
    };
  },

  methods: {
    //获取被助力人信息
    getNeedHelpUserInfo() {
      var t = this;
      var params = {
        // uid: t.myUserInfo.uid,
        // ty:1-本人，2-非本人，为2时必须传uid
        ty: 1
      };
      console.log(params);
      t._get("user", "User.getNeedHelpUserInfo", params)
        .then(res => {
          if (res.status == 0) {
            t.helperInfo = res.data.need_help_user;
            t.helplist = res.data.helper_list;
            t.isme = res.data.isme;
            t.ishelp = res.data.ishelp;
            t.max_help_user = res.data.max_help_user;
          } else {
            // typeof callback == "function" && callback(error);
            t.$toast(res.msg);
          }
        })
        .catch(error => {
          // typeof callback == "function" && callback(error);
          console.log(`error:${error}`);
          t.$toast("请求错误");
        });
    },

    //打开弹窗
    commOpenModal(status) {
      let stu = status;
      if (stu == "undefined") {
        if (this.getBaseUser().isBind == 0) {
          stu = "bindphone";
        } else {
          //去app 使用
          return;
        }
      }
      this.modalStatu = stu;
    },
    //关闭弹窗
    commHideModal(status) {
      // let stu = "hide";
      this.modalStatu = status;
    },
    goshare() {
      var t = this;
      t._deepmain(t.pageId, "homepage2#invite_poster ", 2);
      t.$router.push({
        path: "/shareindex",
        query: {
          iswin: 1,
          vowtext: t.helperInfo.wish_str
        }
      });
    },

    //立即使用
    useAward() {
      var t = this;
      t.$router.push({
        path: "/team",
        query: {}
      });
      return;
      t._deepmain(t.pageId, "activity#reward#use", 2, function() {
        var info = t.awardlist[index];
        console.log("use award info", info);
        // if (info.issku == 1) {
        //   t.activeSku(index);
        //   return;
        // }
        var loading = null;
        setTimeout(() => {
          if (!loading)
            loading = t.$Toast.loading({
              duration: 0, // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              mask: true,
              message: "加载中..."
            });
        }, 200);

        var params = {
          aid: info.id
        };
        console.log(params);
        t._get("user", "User.activeAward", params)
          .then(res => {
            if (loading) loading.clear();
            loading = "stop";
            // <el-radio-group v-model="form.code_type">
            //   <el-radio label="0">券码(无需跳转)</el-radio>
            //   <el-radio label="1">短链接(跳转)</el-radio>
            //   <el-radio label="2">二维码/条形码</el-radio>
            //   <el-radio label="3">sku</el-radio>
            //   <el-radio label="4">直充</el-radio>
            // </el-radio-group>;

            if (res.status == "0") {
              t.$toast("领取成功");
              t.awardlist[index].status = 1;
              t.goAward(info);
            } else {
              t.$toast(res.msg);
            }
          })
          .catch(error => {
            console.log(`error:${error}`);
            if (loading) loading.clear();
            loading = "stop";
          });
      });
    },
    // 处理跳转，已领取的也可以跳转
    goAward(info) {
      var t = this;
      console.log("[nosku]go award", info);
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "正在跳转..."
      });
      //sku奖品
      if (info.code_type == 3) {
        console.log("---打开优惠券列表---");
        try {
          Jegotrip.openRnPage(
            JSON.stringify({ funType: "couponsview", funParams: {} })
          );
        } catch (e) {
          // t.$Toast("网络不给力，请稍后再试");
        }
        loading.clear();
      }
      // 券码链接
      if (info.code_type == 1) {
        var re_href = info.award_code;
        if (re_href.indexOf("://") < 0) re_href = "http://" + info.award_code;
        window.location.href = re_href;
        loading.clear();
      }
    },

    // 查看我的奖品
    goteam() {
      var t = this;
      t.$router.push({
        path: "/team",
        query: {}
      });
      t._deepmain(t.pageId, "homepage2#award", 2);
    },

    // 查看活动规则
    showRule() {
      var t = this;
      this.isshowrule = !this.isshowrule;
      t._deepmain(t.pageId, "homepage2#rules", 2);
    },

    closeWin() {
      this.iswin = -1;
      this.isCountUpper = false;
    },

    showPhone() {
      t.isphone = true;
    },

    //抽奖
    todraw() {
      var t = this;
      t._deepmain(t.pageId, "homepage2#lotterydraw", 2);
      if (t.helperInfo.draw_able_num <= 0) {
        t.isCountUpper = true;
        return false;
      }
      var params = {};
      console.log(params);
      t._get("user", "User.draw", params)
        .then(res => {
          if (res.status == 0) {
            t.iswin = 1;
            t.helperInfo.draw_able_num =
              parseInt(t.helperInfo.draw_able_num) - 1;
            t.myaward = res.data.award_info;
          } else {
            // typeof callback == "function" && callback(error);
            t.iswin = 0;
            t.errMsg = "未中奖，换个姿势再试试";
            if (res.status == 20001) {
              //每天奖品数量上限
              // t.isCount = true
              t.errMsg = "今天奖品已抽完，明天再来吧";
            }
            if (res.status == 50006) {
              //每天每人抽奖次数上限
              t.errMsg = `${res.msg}，明天再来吧`;
            }
            if (res.status == 50007) {
              //每天每人抽奖次数上限
              t.isCountUpper = true;
            }

            // t.$toast(res.msg);
          }
        })
        .catch(error => {
          // typeof callback == "function" && callback(error);
          t.iswin = 0;
          console.log(`error:${error}`);
          // t.$toast("请求错误");
        });
    },

    // 获得更多抽奖机会
    moreDraw() {
      var t = this;
      t.$router.push({
        path: "/shareindex",
        query: {
          iswin: 1,
          vowtext: t.helperInfo.wish_str
        }
      });
    },

    //返回许愿页
    returnVow() {
      var t = this;
      t._deepmain(t.pageId, "homepage2#allwish_access", 2);
      this.$router.push({
        path: "/",
        query: {
          isreturn: true
        }
      });
    }
  },

  mounted() {
    // document
    //   .querySelector("body")
    //   .setAttribute("style", "background-color:#160942"); //初始化 设置此界面的背景颜色
    var t = this;
    // t._getUser(function() {
    //   if (t.myUserInfo.isbindtel == 0) {
    //     t.$toast("您暂未许愿，正在跳转星愿池~");
    //     t.$router.push({
    //       path: "/",
    //       query: {}
    //     });
    //     return false;
    //   }
    t._getUser(function() {
      t.getNeedHelpUserInfo();
      console.log("t.activityInfo");
      console.log(t.activityInfo);
      t._deepmain(t.pageId, "homepage2#access", 0);
    });

    // this.getActivityInfo();
  }
};
</script>

<style scoped lang="scss" src="../../static/scss/vow.scss"></style>
<style scoped lang="scss" src="../../static/scss/vowdraw.scss"></style>
